<template>
  <div class="px-3 py-3 mb-5 col-24 col-md-11">
    <ModalConfirmEmailToken
      v-if="showModalConfirmEmailToken"
      ref="modalEmailToken"
      @credentials="getData"
      @hideModal="(showModalConfirmEmailToken = false), (status = false)"
      :action-type="typeActionSSO"
      :status="status"
    />
    <ModalErrosIdp v-if="showModalError" @close="showModalError = false" />
    <PasswordConfirmationActivationModal
      v-if="actionType"
      @update="getMyProfile(getUserType)"
      :two-factory-authentication="twoFactoryAuthentication"
      :actionType="actionType"
    />
    <div class="col d-column">
      <h1 class="title pt-2 mb-0" v-text="$ml.get('authentication')">
        Autenticação
      </h1>
      <h1 class="title">
        <span class="pb-2" v-text="$ml.get('makeYourAccessEvenMoreSecure')"
          >Torne seu acesso ainda mais seguros</span
        >
      </h1>
      <div class="mb-2">
        <b-nav tabs>
          <b-nav-item
            v-if="
              getUserType === 'company' &&
              !$store.getters['getUser'].ssoSettings.enabled
            "
            :active="menuItem === 'config'"
            @click="menuItem = 'config'"
            id="config"
          >
            {{ $ml.get("lockerConfig") }}
          </b-nav-item>
          <b-nav-item :active="menuItem === 'sso'" @click="menuItem = 'sso'">
            SSO
          </b-nav-item>
        </b-nav>
      </div>

      <div v-if="menuItem === 'config'">
        <div
          v-if="getUserRole === 'owner'"
          class="card mb-3 col-24"
          id="userRestriction"
        >
          <div class="card-header">
            <h6 class="m-0 p-0 light" v-text="$ml.get('restriction')">
              Restrição
            </h6>
          </div>
          <div class="card-body p-0 px-3 mt-3 form-group col-24">
            <div
              class="col-24 d-flex justify-content-between"
              style="gap: 10px"
            >
              <div class="d-flex" style="gap: 10px">
                <label
                  style="font-weight: 500"
                  class="m-0"
                  v-text="$ml.get('labelFeatureTwoFactorAuthentication')"
                  >Somente gestores com Two-factor Authentication podem
                  interagir com relatórios de programas.</label
                >
              </div>
              <label class="switch mb-0 mr-2">
                <input
                  type="checkbox"
                  :checked="twoFactoryAuthentication"
                  @click.prevent="featureActivationAction('2fa')"
                  v-b-modal.modal-email-authentication
                />
                <span class="slider round"></span>
              </label>
            </div>
          </div>
        </div>
        <div
          v-if="canRequestEmailCode && getUserRole === 'owner'"
          class="card mb-3 col-24"
          id="authenticationByEmail"
        >
          <div class="card-header">
            <h6 class="m-0 p-0 light" v-text="$ml.get('authentication')">
              Autenticação
            </h6>
          </div>
          <div class="card-body p-0 px-3 mt-3 form-group col-24">
            <div
              class="col-24 d-flex justify-content-between align-items-center"
            >
              <div class="d-flex" style="gap: 10px">
                <label
                  style="font-weight: 500"
                  class="m-0"
                  v-text="$ml.get('authenticationViaEmail')"
                  >Habilitar autenticação via email</label
                >
                <VueCustomTooltip
                  :label="$ml.get('emailAuthenticationInformation')"
                  :multiline="true"
                  size="is-large"
                >
                  <svg width="16" height="16" class="mb-1">
                    <image
                      xlink:href="../../../src/assets/svg/info-fill.svg"
                      width="16"
                      height="16"
                    />
                  </svg>
                </VueCustomTooltip>
              </div>
              <label class="switch mb-0 mr-2">
                <input
                  type="checkbox"
                  :checked="emailAuthentication"
                  @click.prevent="featureActivationAction('codeEmailCompany')"
                  v-b-modal.modal-email-authentication
                />
                <span class="slider round"></span>
              </label>
            </div>
          </div>
        </div>
        <div v-if="getUserRole === 'owner'" class="card mb-3">
          <div class="card-header">
            <h6 class="m-0 p-0 light" v-text="$ml.get('setPasswordExpiration')">
              Definir expiração de senha
            </h6>
          </div>
          <div class="card-body p-0 px-3 form-group col-24 m-0 mt-3">
            <div
              class="col-24 d-flex justify-content-between align-items-center"
            >
              <label
                style="font-weight: 500"
                class="m-0"
                v-text="$ml.get('enabledPasswordExpiration')"
                >Habilitar expiração de senha</label
              >
              <label class="switch mb-0 mr-2">
                <input
                  type="checkbox"
                  v-model="expirePassword"
                  @click="expirePassword ? updateConfigPassword('disable') : ''"
                />
                <span class="slider round"></span>
              </label>
            </div>
            <div
              class="col-24 d-flex align-items-center justify-content-between mt-3 mb-2"
            >
              <div class="d-flex" v-if="expirePassword == true">
                <label
                  class="mr-1 mt-3"
                  v-text="$ml.get('expirePasswordConfig')"
                  >As senhas dos usuários serão válidas por
                </label>
                <input
                  style="width: 4rem"
                  class="form-control mt-1 text-center"
                  type="number"
                  v-model.trim="numberOfDaysPasswordExpiration"
                />
                <label class="ml-1 mt-3" v-text="$ml.get('daysGeneric') + `.`"
                  >dia(s).</label
                >
                <label v-show="errorConfigPassword" class="lblError">{{
                  $ml.get("isNan")
                }}</label>
              </div>
              <div
                class=""
                v-if="
                  expirePassword == true ||
                  company_settings?.expire_password != expirePassword
                "
              >
                <button
                  v-if="expirePassword"
                  @click="updateConfigPassword"
                  :disabled="
                    loadingPasswordConfig ||
                    (company_settings?.expire_password == expirePassword &&
                      company_settings?.days_to_expire ==
                        numberOfDaysPasswordExpiration)
                  "
                  class="btn mt-1"
                  style="min-width: 100px"
                >
                  <Spinner v-show="loadingPasswordConfig" />
                  <span v-show="!loadingPasswordConfig" v-text="$ml.get('save')"
                    >Salvar</span
                  >
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="menuItem === 'sso'"
        class="mb-4 d-flex align-items-center justify-content-end"
        style="gap: 5px"
      >
        <span
          @click="showModalError = true"
          class="link-erros-idp"
          v-b-modal.modal-erros-idp
          >{{ $ml.get("help") }}</span
        >
      </div>
      <div v-if="menuItem === 'sso'">
        <div class="card">
          <div class="card-header" v-text="$ml.get('paramsConfigIDP')">
            Parâmetros de Configuração do IDP
          </div>
          <div class="card-body">
            <BoxInfo />
          </div>
        </div>
        <div class="card mt-3">
          <div class="card-header">
            <span
              v-if="metadataURLDownload"
              v-text="$ml.get('downloadOrUpdatedXML')"
              >Baixar ou modificar o arquivo XML de integração do IDP</span
            >
            <span v-else v-text="$ml.get('titleAttachXML')"
              >Anexar Arquivo XML de Configuração do IDP</span
            >
          </div>
          <div class="card-body">
            <form class="form-group">
              <div
                class="d-flex align-items-center justify-content-between"
                style="gap: 10px"
              >
                <label
                  class="text-muted"
                  v-if="metadataURLDownload"
                  style="width: 100%; max-width: 250px"
                  v-text="$ml.get('getDownloadXML')"
                  >Obter arquivo de configuração em XML</label
                >
                <label v-else class="text-muted" v-text="$ml.get('titleUrlXML')"
                  >Insira a URL do XML ou faça o upload do seu arquivo
                  XML.</label
                >

                <div
                  v-if="metadataURLDownload"
                  style="margin-bottom: 8px !important"
                >
                  <VueCustomTooltip label="Download">
                    <a
                      :download="metadataURLDownload"
                      :href="metadataURLDownload"
                      class="pointer"
                      @click="$bvModal.show('modal-password')"
                    >
                      <img
                        style="border-radius: 3px !important"
                        width="22"
                        height="22"
                        src="../../assets/icons/download-fill.svg"
                      />
                    </a>
                  </VueCustomTooltip>
                </div>
              </div>
              <hr v-if="metadataURLDownload" class="mt-0 mb-2" />
              <div
                v-if="metadataURLDownload"
                class="d-flex align-items-center justify-content-between mb-2"
                style="gap: 10px"
              >
                <label
                  class="text-muted m-0"
                  style="width: 100%; max-width: 250px"
                  v-text="$ml.get('updateXML')"
                  >Alterar o arquivo XML de integração</label
                >
                <VueCustomTooltip :label="$ml.get('alterXML')">
                  <a class="pointer" @click="editXML = !editXML">
                    <svg width="16" height="16">
                      <image
                        xlink:href="../../../src/assets/icons/edit.png"
                        width="16"
                        height="16"
                      />
                    </svg>
                  </a>
                </VueCustomTooltip>
              </div>
              <input
                type="text"
                class="form-control"
                :placeholder="$ml.get('placeholderUrlXml')"
                v-model.trim="metadataURL"
                v-if="(metadataURLDownload && editXML) || !metadataURLDownload"
              />
              <transition
                v-if="urlError || (metadataURL && xmlError === 'xmlInvalid')"
                class="row"
                name="fade"
              >
                <label class="lblError" v-text="$ml.get('urlIsNotValid')"
                  >A url não é válida!
                </label>
              </transition>
              <div
                class="row mt-3"
                v-if="(metadataURLDownload && editXML) || !metadataURLDownload"
              >
                <input
                  type="file"
                  id="files"
                  ref="file"
                  @change="initUpFile($event.target.files)"
                  class="file-upload none"
                  name="files"
                  multiple
                />
                <transition>
                  <div
                    class="col p-2 d-flex flex-column input-files"
                    align="center"
                  >
                    <h6 class="mt-2" @click="$refs.file.click()">
                      <font class="p-2" v-text="$ml.get('attachXMLFile')"
                        >Anexar Arquivo XML</font
                      >
                      <svg width="20" height="20">
                        <image
                          xlink:href="../../../src/assets/icons/paperclip.svg"
                          width="20"
                          height="20"
                        />
                      </svg>
                    </h6>
                    <p
                      v-for="(item, index) in listFiles"
                      :key="index"
                      class="p-2 my-1 rounded d-flex align-items-center flex-row justify-content-between"
                    >
                      <span>
                        <input
                          class="input-none"
                          :id="'input' + item.id"
                          :value="'[' + item.id + ']'"
                        />
                        <!-- <VueCustomTooltip :label="textTolltip">
                          <b
                            @click="copyLink(item.id)"
                            @mouseout="
                              textTolltip = this.$ml.get('copyLink')
                            "
                            >{{ item.id }}</b
                          >
                        </VueCustomTooltip> -->
                        <!-- : -->
                        <span
                          v-text="
                            item.originalName.substring(0, 40) +
                            (item.originalName.length > 40 ? '... ' : '')
                          "
                        ></span>
                        {{ item.sizeFormat }}
                      </span>
                      <svg @click="removeFile(index)" width="14" height="14">
                        <image
                          xlink:href="../../../src/assets/icons/times.svg"
                          width="14"
                          height="14"
                        />
                      </svg>
                    </p>
                  </div>
                </transition>
              </div>
              <div
                class="mb-4"
                v-if="xmlError === 'xmlInvalid' && !metadataURL"
              >
                <transition class="row" name="fade">
                  <label class="lblError" v-text="$ml.get('xmlError')"
                    >O arquivo XML fornecido não pôde ser processado. Verifique
                    se está bem formatado e atende aos padrões esperados.
                  </label>
                </transition>
              </div>
              <div class="mb-4" v-if="xmlError === 'sizeInvalid'">
                <transition class="row" name="fade">
                  <label class="lblError" v-text="$ml.get('sizeXml')"
                    >O tamanho máximo permitido para o arquivo é 100KB.
                  </label>
                </transition>
              </div>
              <div
                class="mb-4"
                v-if="xmlError === 'errorDefault' && errorDefaultApi"
              >
                <transition class="row" name="fade">
                  <label class="lblError">{{ errorDefaultApi }} </label>
                </transition>
              </div>
              <transition v-if="upload_error" class="row" name="fade">
                <label class="lblError" v-text="$ml.get('allowedFilesAuthSSO')"
                  >Arquivo permitido: .xml
                </label>
              </transition>
              <button
                v-if="(metadataURLDownload && editXML) || !metadataURLDownload"
                :disabled="!metadataURL && !listFiles.length"
                class="btn mt-3"
                v-text="$ml.get('send')"
                @click.prevent="sendXML"
              >
                Enviar
              </button>
            </form>
          </div>
        </div>
        <div class="card mt-3">
          <div class="card-header" v-text="$ml.get('manageDomains')">
            Gerenciar Domínios
          </div>
          <div class="card-body p-0">
            <form
              class="form-group"
              @submit.prevent="registerDomain"
              style="padding: 16px 16px 5px 16px"
            >
              <div class="d-flex align-items-center" style="gap: 10px">
                <div class="col">
                  <input
                    type="text"
                    class="form-control"
                    :placeholder="$ml.get('placeholderUrlDomain')"
                    v-model="domain"
                    :style="{ border: domainError ? '1px solid red' : '' }"
                  />
                  <transition name="fade">
                    <label
                      v-if="domainError === 'invalid'"
                      class="lblError"
                      v-text="$ml.get('domainInvalid')"
                    >
                      Por favor, insira um domínio válido, ex: empresa.com
                    </label>
                    <label
                      v-if="domainError === 'isSame'"
                      class="lblError"
                      v-text="$ml.get('domainIsSame')"
                    >
                      Este domínio já foi registrado. Por favor, escolha outro.
                    </label>
                  </transition>
                </div>
                <button
                  class="btn col-4"
                  style="height: 38px; min-width: 102px"
                  v-text="$ml.get('btnRegister')"
                >
                  Cadastrar
                </button>
              </div>
            </form>
            <hr class="m-0" />
            <div
              v-if="!listDomain.length"
              class="d-flex justify-content-center list-empaty"
            >
              <span v-text="$ml.get('noDomainRegistered')"
                >Nenhum domínio cadastrado.</span
              >
            </div>
            <div v-for="(domain, idx) in listDomain" :key="idx" id="listDomain">
              <div class="item-domain">
                <p v-if="!domain.isEditing" class="col-10">
                  {{ domain.domain }}
                </p>
                <div v-else class="col">
                  <input
                    type="text"
                    class="form-control"
                    v-model="domain.textEditing"
                    @input="domain.errorEditing = false"
                  />

                  <transition
                    v-if="domain.errorEditing"
                    class="row"
                    name="fade"
                  >
                    <label
                      v-if="domain.errorEditing === 'urlInvalid'"
                      class="lblError"
                      v-text="$ml.get('domainInvalid')"
                      >Por favor, insira um domínio válido, ex: empresa.com
                    </label>
                    <label
                      v-if="domain.errorEditing === 'isSame'"
                      class="lblError"
                      v-text="$ml.get('domainIsSame')"
                      >Este domínio é inválido ou já foi registrado. Por favor,
                      escolha outro.
                    </label>
                  </transition>
                </div>
                <div v-if="!domain.isEditing" class="col-10">
                  <div
                    class="tagsListReport justify-content-center"
                    style="width: 85px"
                  >
                    <span
                      v-if="domain.status === 'pending'"
                      v-text="$ml.get('pending')"
                      >Pendente</span
                    >
                    <span v-else v-text="$ml.get('validated')">Validado</span>
                  </div>
                </div>
                <div
                  class="d-flex ml-2 col-4"
                  style="
                    gap: 10px;
                    align-items: self-start;
                    justify-content: end;
                  "
                >
                  <div
                    class="d-flex align-items-center"
                    style="padding: 0px 5px 0px 0px"
                  >
                    <div
                      v-if="!domain.isEditing && domain.status === 'pending'"
                      @click="
                        (domain.isEditing = true),
                          (domain.textEditing = domain.domain)
                      "
                    >
                      <VueCustomTooltip
                        :label="$ml.get('editDomain')"
                        class="mr-2"
                      >
                        <svg width="16" height="16">
                          <image
                            xlink:href="../../../src/assets/icons/edit.png"
                            width="16"
                            height="16"
                          />
                        </svg>
                      </VueCustomTooltip>
                    </div>
                    <div
                      v-if="domain.isEditing && domain.status === 'pending'"
                      @click="updateDomain(domain)"
                    >
                      <VueCustomTooltip :label="$ml.get('save')" class="mr-2">
                        <svg width="22" height="22">
                          <image
                            xlink:href="../../../src/assets/icons/check-save.svg"
                            width="22"
                            height="22"
                          />
                        </svg>
                      </VueCustomTooltip>
                    </div>
                    <div
                      v-if="!domain.isEditing"
                      @click="deleteDomain(domain.domain)"
                    >
                      <VueCustomTooltip :label="$ml.get('removeDomain')">
                        <svg width="16" height="16">
                          <image
                            xlink:href="../../../src/assets/icons/trash-alt.svg"
                            width="16"
                            height="16"
                          />
                        </svg>
                      </VueCustomTooltip>
                    </div>
                    <div
                      v-else
                      @click="
                        (domain.isEditing = false),
                          (domain.errorEditing = false)
                      "
                    >
                      <VueCustomTooltip :label="$ml.get('cancel')">
                        <p class="m-0" style="font-size: 30px; color: #9c27b0">
                          -
                        </p>
                      </VueCustomTooltip>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="domain.status === 'pending'"
                class="d-flex form-group"
                style="padding: 4px 16px 5px 16px"
              >
                <div class="col box-key">
                  <div class="col">
                    <span class="key-config">{{ domain.key }}</span>
                  </div>

                  <div
                    id="copyKey"
                    class="d-flex align-items-center col-4 justify-content-end"
                    style="gap: 8px"
                  >
                    <div class="circle-info">
                      <VueCustomTooltip
                        :label="
                          $ml.get('swalInfoValidateDomain') +
                          domain.domain +
                          $ml.get('swalAfterValidateDomain')
                        "
                        :multiline="true"
                        size="is-large"
                      >
                        <span>!</span>
                      </VueCustomTooltip>
                    </div>

                    <div @click="copyToClipboard(domain.key)">
                      <VueCustomTooltip :label="$ml.get('copyContent')">
                        <svg class="ico-20">
                          <image
                            xlink:href="../../assets/icons/copy-fill.svg"
                            width="20"
                            height="20"
                          />
                        </svg>
                      </VueCustomTooltip>
                    </div>
                  </div>
                </div>
                <button
                  class="btn col-4 ml-2"
                  style="height: 38px; min-width: 102px"
                  @click="sendDomain(domain.domain)"
                  v-text="$ml.get('btnValidated')"
                >
                  Validar
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="card mt-3">
          <div class="card-header">SSO - Single Sign-On</div>
          <div class="card-body">
            <div
              class="col-24 d-flex justify-content-between align-items-center"
            >
              <div class="d-flex" style="gap: 10px">
                <p style="font-weight: 500" class="m-0">
                  {{ $ml.get("activeSSO") }}
                  <VueCustomTooltip
                    :label="$ml.get('tooltipSSO')"
                    :multiline="true"
                    size="is-large"
                  >
                    <svg width="16" height="16" class="ml-2 mb-1">
                      <image
                        xlink:href="../../../src/assets/svg/info-fill.svg"
                        width="16"
                        height="16"
                      />
                    </svg>
                  </VueCustomTooltip>
                </p>
              </div>
              <VueCustomTooltip
                :label="
                  !emailVerified || !metadataURLDownload
                    ? $ml.get('tooltipActiveSSO')
                    : ''
                "
                class="mr-2"
                :multiline="true"
                size="is-large"
              >
                <label class="switch mb-0 mr-2">
                  <input
                    type="checkbox"
                    :disabled="!emailVerified || !metadataURLDownload"
                    v-model="SSOStatus"
                    v-b-modal.modal-email-token
                    @click.prevent="
                      (typeActionSSO = 'SSO'),
                        (showModalConfirmEmailToken = true),
                        (status = SSOStatus)
                    "
                  />
                  <span class="slider round"></span>
                </label>
              </VueCustomTooltip>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { mapActions } from "vuex";
import AccountService from "../../services/account.service";
import companyService from "../../services/company.service";
import ssoService from "../../services/sso.service";
import BoxInfo from "../BoxInfo.vue";
import ModalConfirmEmailToken from "../modais/ModalConfirmEmailToken.vue";
import ModalErrosIdp from "../modais/ModalErrosIdp.vue";
import PasswordConfirmationActivationModal from "../modais/PasswordConfirmationActivationModal.vue";
export default {
  components: {
    PasswordConfirmationActivationModal,
    BoxInfo,
    ModalConfirmEmailToken,
    ModalErrosIdp,
  },
  data() {
    return {
      showModalError: false,
      errorAtributteEmail: false,
      errorUsername: false,
      errorCertificate: false,
      errorSystemClocks: false,
      errorAudienceRestriction: false,
      errorAssertion: false,
      errorMalformed: false,
      errorSAMLAssertion: false,
      errorRelayState: false,
      errorDefaultApi: "",

      showCause: false,
      menuItem: "config",
      listFiles: [],
      upload_error: false,
      getUserType: "",
      getUserRole: "",
      twoFactoryAuthentication: false,
      actionType: "",
      canRequestEmailCode: false,
      emailAuthentication: false,
      expirePassword: false,
      numberOfDaysPasswordExpiration: "",
      company_settings: null,
      errorConfigPassword: false,
      loadingPasswordConfig: false,
      domain: "",
      listDomain: [],
      showModalConfirmEmailToken: false,
      typeActionSSO: null,
      SSOStatus: false,
      domainError: false,
      metadataURL: "",
      metadataURLDownload: "",
      urlError: false,
      xmlError: "",
      editXML: false,
      emailVerified: null,
    };
  },
  watch: {
    numberOfDaysPasswordExpiration() {
      this.errorConfigPassword = false;
    },
    domain() {
      this.domainError = "";
    },
    metadataURL() {
      this.urlError = false;
      this.xmlError = "";
    },
    listFiles() {
      this.xmlError = "";
    },
  },
  mounted() {
    this.getUserType = this.$store.getters["getUserType"];
    this.getUserRole = this.$store.getters["getUserRole"];

    this.getMyProfile(this.getUserType);

    if (this.$store.getters["getUser"].ssoSettings.enabled) {
      this.menuItem = "sso";
    }

    if (this.$store.getters["getUserType"] == "company") {
      this.company_settings = this.$store.getters["getUser"].company_settings;
      this.expirePassword =
        this.company_settings.expire_password == true
          ? this.company_settings.expire_password
          : false;
      this.numberOfDaysPasswordExpiration =
        this.company_settings.expire_password == true
          ? this.company_settings.days_to_expire
          : 0;
    }
  },

  methods: {
    ...mapActions(["setUser", "setAmountPrograms"]),

    copyToClipboard(content) {
      navigator.clipboard
        .writeText(content)
        .then(() => {
          Swal.fire({
            icon: "success",
            title: this.$ml.get("swalTitleCopy"),
            text: this.$ml.get("swalTextCopy"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 1500,
            timerProgressBar: true,
          });
        })
        .catch((err) => {
          console.error("Erro ao copiar o conteúdo: ", err);
        });
    },

    async sendDomain(name) {
      try {
        const { status } = await ssoService.postValidateDomain({
          domain: name,
        });
        if (status === 201) {
          Swal.fire({
            icon: "success",
            title: this.$ml.get("swalValidateSuccess"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });
        }
        this.getMyProfile(this.getUserType);
      } catch (error) {
        Swal.fire({
          icon: "warning",
          title: `${this.$ml.get(
            "swalErrorValidateDomain"
          )} "${name}" ${this.$ml.get("swalTryAgain")}`,
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });
        console.error("Erro na validação do domínio:", error);
      }
    },
    async sendXML() {
      this.urlError = false;
      this.xmlError = "";
      this.errorDefaultApi = "";
      try {
        const formData = new FormData();

        if (this.metadataURL) {
          formData.append("metadataURL", this.metadataURL);
        } else {
          formData.append("metadataFile", this.listFiles[0]);
        }

        const { status } = await ssoService.postXML(formData);

        if (status === 201) {
          Swal.fire({
            icon: "success",
            title: this.$ml.get("registerSucess"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });

          this.getMyProfile(this.getUserType);
        }
        this.editXML = false;
        this.metadataURL = "";
        this.listFiles = [];
      } catch (error) {
        // console.log(error.response.data.message);
        if (error.response.data.message[0] === "Tamanho inválido") {
          this.xmlError = "sizeInvalid";
          return;
        } else if (
          error.response.data.message[0] === "metadataURL must be a URL address"
        ) {
          this.urlError = true;
          return;
        } else if (error.response.data.message === "Input XML is invalid") {
          this.xmlError = "xmlInvalid";
          return;
        } else if (error.response.status != 500) {
          this.xmlError = "errorDefault";
          this.errorDefaultApi = error.response.data.message;
        }
      }
    },

    async deleteDomain(item) {
      if (this.listDomain.length === 1 && this.SSOStatus) {
        Swal.fire({
          heightAuto: false,
          icon: "warning",
          title: this.$ml.get("swalActionNotPermitted"),
          text: this.$ml.get("swalOneRegisteredDomain"),
          timer: 3000,
          timerProgressBar: true,
          showConfirmButton: false,
          customClass: {
            popup: "swal2-center",
          },
        });
        return;
      }
      try {
        const result = await Swal.fire({
          heightAuto: false,
          text:
            this.$ml.get("swalYouSure") + " " + this.$ml.get("swalWarningInfo"),
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: this.$ml.get("remove"),
          cancelButtonText: this.$ml.get("cancel"),
          allowOutsideClick: false,
        });

        if (result.isConfirmed) {
          const { status } = await ssoService.deleteDomain(item);

          if (status === 200) {
            await Swal.fire({
              heightAuto: false,
              title: this.$ml.get("swalActionPerformed"),
              text: this.$ml.get("swalActionCuccessfully"),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
            });

            this.getMyProfile(this.getUserType);
          }
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          console.log("Ação cancelada");
        }
      } catch (error) {
        if (
          error.response.data.message ===
          "Não é permitido excluir domínio vinculado ao owner."
        ) {
          Swal.fire({
            heightAuto: false,
            icon: "warning",
            title: this.$ml.get("swalActionNotPermitted"),
            text: this.$ml.get("swalAlertOwner"),
            timer: 3000,
            timerProgressBar: true,
            showConfirmButton: false,
            customClass: {
              popup: "swal2-center",
            },
          });
          return;
        }
        if (
          error.response.data.message === "Necessário ter ao menos 1 domínio."
        ) {
          Swal.fire({
            heightAuto: false,
            icon: "warning",
            title: this.$ml.get("swalActionNotPermitted"),
            text: this.$ml.get("swalOneRegisteredDomain"),
            timer: 3000,
            timerProgressBar: true,
            showConfirmButton: false,
            customClass: {
              popup: "swal2-center",
            },
          });
          return;
        }
        console.error(
          "Erro ao excluir domínio:",
          error?.response?.data || error.message
        );
      }
    },

    getData(data) {
      const { emailToken } = data;
      this.activeSSO(emailToken);
    },

    async activeSSO(token) {
      this.$refs.modalEmailToken.loadingBtn = true;
      try {
        const payload = {
          SSOEmailToken: Number(token),
        };
        const { status } = await ssoService.putSSO(payload);
        if (status === 200) {
          this.showModalConfirmEmailToken = false;
          Swal.fire({
            icon: "success",
            title: this.$ml.get("updateConfigSSO"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });

          this.getMyProfile(this.getUserType);
          this.$refs.modalEmailToken.loadingBtn = false;
        }
      } catch (error) {
        console.log(error.response.data.message);
        this.$refs.modalEmailToken.loadingBtn = false;
        setTimeout(() => {
          if (
            error.response.data.message ===
            "Necessário registrar/verificar o domínio do owner!"
          ) {
            this.$refs.modalEmailToken.errorDomain = true;
          }
          if (error.response.data.message === "Token não é válidas.") {
            this.$refs.modalEmailToken.errorCodeEmail = true;
          }
          this.$bvModal.show("modal-email-token");
        }, 500);
      }
    },
    async updateDomain(item) {
      try {
        const result = await Swal.fire({
          heightAuto: false,
          text:
            this.$ml.get("swalYouSure") + " " + this.$ml.get("swalWarningInfo"),
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: this.$ml.get("save"),
          cancelButtonText: this.$ml.get("cancel"),
          allowOutsideClick: false,
        });

        if (result.isConfirmed) {
          if (item.domain === item.textEditing) {
            item.isEditing = false;
            return;
          }
          const { status } = await ssoService.updateDomain(item.id, {
            domain: item.textEditing,
          });

          if (status === 200) {
            await Swal.fire({
              heightAuto: false,
              title: this.$ml.get("swalActionPerformed"),
              text: this.$ml.get("swalActionCuccessfully"),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
            });

            this.getMyProfile(this.getUserType);
          }
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          console.log("Ação cancelada");
        }
      } catch (error) {
        if (error.response.data.message[0] === "domain must be a URL address") {
          item.errorEditing = "urlInvalid";
          return;
        }
        if (error.response.data.message === "Domínio já registrado") {
          item.errorEditing = "isSame";
          return;
        }
        console.error(
          "Erro ao excluir domínio:",
          error?.response?.data || error.message
        );
      }
    },

    async registerDomain() {
      this.domainError = "";
      try {
        if (!this.domain) return;
        const { status } = await ssoService.postDomainSSO({
          domain: this.domain,
        });

        if (status == 201) {
          Swal.fire({
            icon: "warning",
            title: this.$ml.get("attention"),
            text: this.$ml.get("validatedDomain"),
            confirmButtonText: this.$ml.get("undestand"),
            timer: 10000,
            timerProgressBar: true,
          });

          this.getMyProfile(this.getUserType);
          this.domain = "";
        }
      } catch (error) {
        if (error.response.data.message === "Domínio já registrado") {
          this.domainError = "isSame";
          return;
        }
        this.domainError = "invalid";
      }
    },

    removeFile(item) {
      document.getElementById("files").value = "";
      this.listFiles.splice(item, 1);
    },
    initUpFile(files) {
      var self = this;

      if (files) {
        if (files.length + self.listFiles.length > 1) {
          document.getElementById("files").value = "";

          Swal.fire({
            heightAuto: false,
            html: `<h4 class="mb-1">${self.$ml.get("maximumFilesAuthSSO")}</h4>
                  <label>
                   ${self.$ml.get("replaceFileAuthSSO")}
                  </label>
                  `,
            customClass: "swal-2fa",
            showCancelButton: false,
            confirmButtonText: self.$ml.get("return"),
            confirmButtonColor: "#730BA9",
          });

          return;
        }

        this.upload_error = false;

        Array.from(files).forEach((element, index) => {
          if (this.$utils.uploadVerifyXML(element)) {
            this.upload_error = this.$utils.uploadVerifyXML(element);
            console.log(this.upload_error);
            return;
          }

          let fileSize = element.size.toString();
          let sizeFormat = "";

          if (fileSize.length < 7) {
            sizeFormat = `${Math.round(+fileSize / 1024).toFixed(2)}kb`;
          } else {
            sizeFormat = `${(Math.round(+fileSize / 1024) / 1000).toFixed(
              2
            )}MB`;
          }

          let id =
            "F" + String(element.lastModified * (index + 3)).substr(4, 4);
          let originalName = element.name;

          let name = JSON.stringify({
            id: id,
            sizeFormat: sizeFormat,
            name: element.name,
          });

          element = new File([element], name, {
            type: element.type,
          });

          element.id = id;
          element.sizeFormat = sizeFormat;
          element.originalName = originalName;

          self.listFiles.push(element);
        });
      }
    },
    formatObj(data) {
      return data.map((i) => ({
        ...i,
        textEditing: "",
        isEditing: false,
        errorEditing: false,
      }));
    },

    getMyProfile(type) {
      var self = this;

      AccountService.getAccountMy().then((response) => {
        if (type == "company") {
          self.setUser({
            account_avatar: response.data.account_avatar,
            account_createdAt: response.data.account_createdAt,
            companyName: response.data?.companyName,
            company_avatar: response.data?.company_avatar,
            company_settings: response.data?.settings,
            company_createdAt: response.data.company_createdAt,
            email: response.data.email,
            name: response.data.name,
            role: response.data?.role,
          });
          self.setAmountPrograms(response.data.amount_of_programs);
          self.twoFactoryAuthentication =
            response.data.settings.two_factor_auth_required;
          self.canRequestEmailCode =
            response?.data?.plan?.can_request_email_code;
          self.emailAuthentication =
            response?.data?.settings?.email_code_required;
          this.company_settings =
            this.$store.getters["getUser"].company_settings;
          this.expirePassword =
            this.company_settings.expire_password == true
              ? this.company_settings.expire_password
              : false;
          this.numberOfDaysPasswordExpiration =
            this.company_settings.expire_password == true
              ? this.company_settings.days_to_expire
              : 0;

          this.$store.dispatch("setUser", {
            two_factor_auth_login: response.data?.two_factor_auth_login,
            email_code_required: response.data?.email_code_required,
            ssoSettings: response.data?.ssoSettings,
          });

          this.SSOStatus = response.data?.ssoSettings?.enabled;
          this.listDomain = this.formatObj(
            response.data?.ssoSettings?.allowedDomains
          );

          this.emailVerified = this.listDomain.find(
            (item) => item.status === "verified"
          );
          this.metadataURLDownload = response.data?.ssoSettings?.metadata;

          if (response.data?.ssoSettings?.enabled) {
            this.menuItem = "sso";
          }
        }
      });
    },
    featureActivationAction(type) {
      this.actionType = type;
    },
    async updateConfigPassword(actionOpcional) {
      this.errorConfigPassword = false;
      this.loadingPasswordConfig = true;

      const convertToNumber = Number(this.numberOfDaysPasswordExpiration);
      if (isNaN(convertToNumber)) {
        this.loadingPasswordConfig = false;
        return (this.errorConfigPassword = true);
      }

      try {
        const payload = {
          active:
            actionOpcional != "disable" &&
            Number(this.numberOfDaysPasswordExpiration) > 0
              ? this.expirePassword
              : !this.expirePassword,
          days: Number(this.numberOfDaysPasswordExpiration),
        };
        if (Number(this.numberOfDaysPasswordExpiration) <= 0) {
          if (actionOpcional != "disable") {
            Swal.fire({
              icon: "warning",
              title: this.$ml.get("swalTotalDays"),
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            });
          }
          this.loadingPasswordConfig = false;
          return;
        }
        const { status } = await companyService.putPasswordConfig(payload);

        const requestedCuccessfully = 200;
        if (status === requestedCuccessfully) {
          Swal.fire({
            icon: "success",
            title: this.$ml.get("configSuccess"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });

          let userType = this.$store.getters["getUserType"];
          this.getMyProfile(userType);
        }
        this.loadingPasswordConfig = false;
      } catch (error) {
        if (error.response.data.statusCode === 403) {
          Swal.fire({
            icon: "info",
            html: `<h4 class="mb-1">${this.$ml.get(
              "userDoesNotHavPermissionToPerform"
            )}</h4> 
              <label> 
              </label>  
              `,
            showConfirmButton: false,
            timer: 30000,
          });
        }
        this.loadingPasswordConfig = false;
      }
    },
  },
};
</script>
<style scoped>
.item-domain {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 16px;
}
.item-domain > p {
  font-weight: 400;
  margin: 0px;
}
.list-empaty {
  background: #ececec1f;
  padding: 10px;
  font-weight: 400;
}
#listDomain {
  border-bottom: 1px solid #d4d4d4;
}
.circle-info {
  min-width: 16px;
  min-height: 16px;
  border: 1px solid #9c27b0;
  color: #9c27b0;
  border-radius: 50%;
  font-size: 12px;
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
}
.box-key {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  background: #e9ecef;
  border-radius: 8px;
  padding: 10px;
}
.key-config {
  font-size: 14px;
}

.link-erros-idp {
  color: #87109b;
  cursor: pointer;
  font-weight: 400;
}
</style>
